import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { baseAxiosNoInfo } from "../../../tool/axios"

export default function () {

    const param: { check_in_id: string } = useParams()

    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<any[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/customer/dining_reception/page_list', {
            params: {
                check_in_id: param.check_in_id
            }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [])

    return <div className="follow-record">
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 随餐接待记录 */}
        {data.length === 0 && '暂无数据'}

        {data.map((el: any) => <ul style={{ listStyle: 'none' }}>
            <li>
                <p className="date">跟进日期：{el.receive_date}</p>
            </li>
            <li>
                <p>过敏食材：{el.guomin_food_item_name}</p>
            </li>
            <li>
                <p>禁忌食材：{el.jinji_food_item_name}</p>
            </li>
            <li>
                <p>水肿情况：{el.has_shuizhong_desc}</p>
            </li>
            <li>
                <p>排便情况：{el.paibian_status_desc}</p>
            </li>
            <li>
                <p>其他：{el.other_exception}</p>
            </li>
        </ul>)}

        {/* {showLoadBtn  &&  <Button onClick={()=>{
            setPage(page+1)
        }}>加载更多数据</Button>} */}
    </div>
}